import type { ValidatePatientResponseWithScheduledAppointments } from "@/lib/__generated/api";

import { dataLayerPush } from "./dataLayerHelpers";

export const dataLayerPushExistingAccount = (
  interaction: string,
  webFacilityDetails: any,
  validatedPatient: ValidatePatientResponseWithScheduledAppointments | null | undefined,
  errorCode?: string,
  modalPrompt?: string,
) => {
  let modal_purpose = "existing account";
  let patient_type = "existing patient";

  if (errorCode === "TU_FAIL") {
    modal_purpose = "fraud detection";
    patient_type = "fraudulent patient";
  } else if (errorCode === "existingPatient_with_appt") {
    patient_type = "existing patient with appointment";
  } else if (errorCode === "existingPatient_no_appt") {
    patient_type = "existing patient no appointment";
  } else if (errorCode === "newPatient_with_appt") {
    patient_type = "new patient with appointment";
  }

  dataLayerPush({
    event: "modal",
    modal_location: "scheduler",
    modal_purpose: modal_purpose,
    modal_prompt: modalPrompt ?? "it looks like you already have an account with us",
    modal_interaction: interaction,
    patient_type: patient_type,
    website_selected_facility_id: webFacilityDetails?.code,
    website_selected_facility_name: webFacilityDetails?.name,
    can_schedule: validatedPatient?.canSchedule,
    new_patient: validatedPatient?.newPatient,
    child_patient: validatedPatient?.childPatient,
    digiact: validatedPatient?.digiact,
    has_scheduled_appointment: validatedPatient?.hasScheduledAppointment,
    appointment_time: validatedPatient?.appointmentTime,
    facility_code: validatedPatient?.facilityCode,
  });
};
